<template>
    <div class="animated fadeIn">
        <div v-if="saving">
            <semipolar-spinner :animation-duration="2000" :size="65" color="#ff1d5e" />Salvo...
        </div>
        <div v-if="saving" class="overlay"></div>
        <div>
            <template v-if="!noprogsel">
            <hr />Progetto:
            <multiselect id="progettilist" v-model="progsel" :options="progetti" :multiple="false" :close-on-select="true" label="nome" track-by="progettoid" @input="fprogsel"></multiselect>
            </template>
            <hr />Corsista:
            <multiselect id="alunnilist" v-model="alsel" :options="alunni" :multiple="false" :close-on-select="true" label="nome" track-by="alunnoid" @input="falsel"></multiselect>
            <h1>
                {{ nome }}
            </h1>
            <div style="float:left;width:250px;height:70px;">
                Modalità:
                <multiselect id="modolist" :allow-empty="false" v-model="modosel" :options="modi" :multiple="false" :close-on-select="true" label="text" track-by="id" @input="modsel">
                </multiselect>
            </div>
            <template v-if="ENAC || GREEN">
                <div style="float:left;width:100px;position:relative;height:70px;margin-left: 30px;">
                    <button class="btn btn-info" @click="copia" :disabled="!copiaEnabled" style="position: absolute;bottom: 6px;">Copia</button>
                </div>
                <div style="float:left;width:100px;position:relative;height:70px;">
                    <button class="btn btn-info" @click="incolla" :disabled="!incollaEnabled" style="position: absolute;bottom: 6px;">Incolla</button>
                </div>
            </template>
            <div style="clear: both;"></div>
            <br>
        </div>
        <full-calendar id="calendar" :options="calendarOptions" @event-render="eventRender" ref="fcc"></full-calendar>
    </div>
</template>

<script>
// import "fullcalendar/dist/locale/it";
import { API } from "@/api.js";
import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import bootstrapPlugin from '@fullcalendar/bootstrap';
import listPlugin from '@fullcalendar/list';
import adaptivePlugin from '@fullcalendar/adaptive'
import itLocale from '@fullcalendar/core/locales/it';
import 'bootstrap/dist/css/bootstrap.css';
import { SemipolarSpinner } from "epic-spinners";
import { DateTime } from "luxon";
window.jQuery = require("jquery");
require("print-this");

export default {
    name: "CalPers",
    mixins: [window.myMixin],
    components: {
        SemipolarSpinner,
        FullCalendar,
    },
    data: function () {
        var io = this;
        return {
            noprogsel: false,
            calendarOptions: {
                editable: true,
                eventDrop: this.eventDrop,
                eventOverlap: false,
                plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, bootstrapPlugin, listPlugin, adaptivePlugin],
                initialView: 'dayGridMonth',
                eventClick: this.eventClick,
                headerToolbar: {
                    left: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
                    center: 'title',
                    right: 'today prev,next'
                },
                themeSystem: 'bootstrap',
                locale: itLocale,
                schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                hiddenDays: window.ENAC ? [] : [0],
                slotMinTime: '06:00:00',
                slotMaxTime: '23:00:00',
                allDaySlot: false,
                eventTimeFormat: {
                    omitZeroMinute: false,
                    hour: '2-digit',
                    minute: '2-digit',
                },
                viewDidMount: (...args) => {
                    console.log("VIEWRENDER2", args)
                },
                eventsSet: (...args) => {
                    console.log("EVENTSET", args, this.calendarOptions)
                },
                datesSet: function (dateInfo) {
                    var view = dateInfo.view;
                    console.log("dateset", view)
                    io.viewType = view.type
                },
                eventSources: [
                    {
                        events(info, callback) {
                            console.log("start:", info);
                            // nascondo il div.fc-view-harness
                            let div = document.querySelector("div.fc-view-harness")
                            if (div) div.style.display = "none";
                            io.$http
                                .get(window.baseurl + "/tshowcalpers", {
                                    params: {
                                        json: 1,
                                        start: info.startStr.split("T")[0],
                                        end: info.endStr.split("T")[0],
                                        cid: io.alsel ? io.alsel.corsistaid : false
                                    },
                                })
                                .then((response) => {
                                    // console.log("RESP:", response.data);
                                    // response.data.map(d => ({...d, allDay: false }))
                                    console.log("RESP:", response.data, io.modosel.id);
                                    // mostro il div.fc-view-harness
                                    let div = document.querySelector("div.fc-view-harness")
                                    if (div) div.style.display = "block";
                                    io.lastEvents = JSON.parse(JSON.stringify(response.data))
                                    if (io.copyEvents) {
                                        io.copiedEvents = JSON.parse(JSON.stringify(response.data))
                                        io.copyEvents = false
                                    }
                                    if (io.modosel.id == 1)
                                        for (let d of response.data) {
                                            d.start = d.startorig
                                            d.end = d.endorig
                                        }
                                    callback(response.data);
                                });
                        },
                        color: "black",
                        textColor: "white",
                    },
                ],
            },
            lastEvents: false,
            copiedEvents: false,
            copyEvents: false, // se va a true copia gli eventi oltre a caricarli
            okStage: false,
            backOK: false, // modifiche retroattive per debug)
            saving: false,
            insOptions: [],
            chooseOk: false,
            noOre: false,
            okDel: false,
            okIns: false,
            cal2del: false,
            dateIns: "",
            calid: 0,
            present: false,
            sostegno: false,
            canEdit: false,
            viewType: "",
            progsel: {},
            progetti: [],
            alsel: {},
            alunni: [],

            modosel: { id: 0, text: "reale" },
            modi: [{ id: 0, text: "reale" }, { id: 1, text: "originale" }],
            clickCount: 0,
            clickTimer: null,
        };
    },
    async mounted() {

    },
    computed: {
        nome() {
            return this.alsel ? this.alsel.nome : '';
        },
        copiaEnabled() {
            return this.viewType == 'timeGridWeek' && this.lastEvents && this.lastEvents.length > 0
        },
        incollaEnabled() {
            return this.viewType == 'timeGridWeek' && this.copiedEvents && this.copiedEvents.length > 0
        },
        loctime() {
            if (window.DEBUG)
                return window.loctime || DateTime.local()
            else
                return window.loctime_par || DateTime.local() // loctime passato come parametro (per debug, ma su versione di produzione)
        },
        loctimeSQL() {
            return this.loctime.toFormat('yyyy-MM-dd HH:mm:ss')
        },
    },
    created: async function () {
        var url = new URL(window.location.href);
        var progettoid = url.searchParams.get("progettoid");
        console.log("CREATED CALPERS", url, progettoid);

        let tsedi = await API.sqlprep(this, "registro.selsedi", []);
        console.log("SEDI:", tsedi)
        let sedi = []
        for (let sede of tsedi.data.dati) {
            sedi[sede.sedeid] = sede.nome
        }
        var token = this.getTokenData().sub;
        console.log("TOKEN", token)

        let prgs
        if (progettoid) // dal SW potrebbe arrivare la richiesta per un progetto di una sede diversa
            prgs = await API.sqlprep(this, "registro.selprog", []);
        else if (this.getUserLIV() < 3)
            prgs = await API.sqlprep(this, "registro.selproginc", [token.user.docenteid, token.user.docenteid]);
        else if (this.getUserLIV() >= 5)
            prgs = await API.sqlprep(this, "registro.selprog", []);
        else
            prgs = await API.sqlprep(this, "registro.selprogsede", [token.user.sedeid]);
        this.progetti = prgs.data.dati
            .filter(p => !this.ECFOP || p.oretirocinio > 0)
            .map(p => ({
                progettoid: p.progettoid,
                annualita: p.annualita,
                sedeid: p.sedeid,
                nome: `${sedi[p.sedeid]}: ${p.annualita} ${p.sezione || ''} - ${p.numero} - ${p.nome}`,
            }))
            .sort((a, b) => {
                if (a.nome < b.nome) return -1;
                else if (a.nome > b.nome) return 1;
                else return 0;
            });
        if (progettoid) {
            this.progsel = this.progetti.find(p => p.progettoid == progettoid);
            this.noprogsel = true;
            this.fprogsel();
        }
    },
    methods: {
        copia: async function () {
            console.log("COPIA")
            // ricarico tutto perché potrei averli cambiati
            this.copyEvents = true
            let calendar = this.$refs.fcc.getApi()
            let dbg = calendar.refetchEvents()
            console.log("DBG", dbg)
        },
        incolla: async function () {
            this.saving = true
            console.log("INCOLLA", JSON.stringify(this.lastEvents), JSON.stringify(this.copiedEvents))
            for (let e of this.lastEvents.sort((a, b) => a.start.localeCompare(b.start)))
                console.log("last", JSON.stringify(e))
            for (let e of this.copiedEvents.sort((a, b) => a.start.localeCompare(b.start)))
                console.log("last", JSON.stringify(e))
            let alid = this.alsel.alunnoid
            // elimino dal target tutti gli elementi diversi
            // per prima cosa copio tutto ripristinando quelli diversi
            let eventi = []
            for (let e of this.lastEvents) {
                if (e.start != e.startorig) {
                    console.log("Elimino", e)
                    await API.sqlprep(this, "calendario.calcors1", [e.calid, alid]);
                    e.star = e.starttorig
                }
                eventi.push(e)
            }
            console.log("eventi", eventi.length)
            // calcolo la differenza in settimane fra le prime date facendo attenzione al cambio anno
            let dest = DateTime.fromSQL(eventi[0].startorig)
            let orig = DateTime.fromSQL(this.copiedEvents[0].startorig)
            console.log("DIFF", dest, dest.weekday, orig, orig.weekday)
            // sottraggo i giorni per avere due date di lunedì
            dest = dest.minus({ days: dest.weekday - 1 })
            orig = orig.minus({ days: orig.weekday - 1 })

            let diff = DateTime.fromSQL(eventi[0].start).weekNumber - DateTime.fromSQL(this.copiedEvents[0].start).weekNumber
            console.log("DIFF", diff)
            // adesso tutti quelli copiati "diversi" li copio se hanno una corrispondenza
            for (let e of this.copiedEvents) {
                if (e.start != e.startorig) {
                    console.log("diverso", e, DateTime.fromSQL(e.startorig).weekday, DateTime.fromSQL(e.startorig).hour)
                    console.log("Trovo:", eventi.find(e2 => DateTime.fromSQL(e2.startorig).weekday == DateTime.fromSQL(e.startorig).weekday
                        && DateTime.fromSQL(e2.startorig).hour == DateTime.fromSQL(e.startorig).hour))
                }
                if (e.start != e.startorig) {
                    let dest = eventi.find(e2 => DateTime.fromSQL(e2.startorig).weekday == DateTime.fromSQL(e.startorig).weekday
                        && DateTime.fromSQL(e2.startorig).hour == DateTime.fromSQL(e.startorig).hour)
                    if (dest) {
                        let diff = DateTime.fromSQL(e.start).diff(DateTime.fromSQL(e.startorig), 'minutes').minutes
                        let ts = DateTime.fromSQL(dest.startorig).plus({ minutes: diff }).toSQL().substring(0, 19)
                        console.log("Copio", e, dest, ts)
                        await API.sqlprep(this, "calendario.calcors2", [dest.calid, alid, ts]);
                    }
                }
            }
            let calendar = this.$refs.fcc.getApi()
            calendar.refetchEvents()
            this.saving = false
        },
        eventDrop: async function (evt) {
            console.log("DRAGGED!", evt)
            console.log("DRAGGED1", evt.event._instance.range.start.toISOString())
            console.log("DRAGGED2", evt.event._def.extendedProps)
            let alid = this.alsel.alunnoid
            let calid = evt.event._def.extendedProps.calid
            let ts = evt.event._instance.range.start.toISOString().substring(0, 19).replace("T", " ")
            console.log(alid, calid, ts)
            await API.sqlprep(this, "calendario.calcors1", [calid, alid]);
            await API.sqlprep(this, "calendario.calcors2", [calid, alid, ts]);
            let calendar = this.$refs.fcc.getApi()
            calendar.refetchEvents()
        },
        falsel: async function (evt) {
            console.log("falsel", this.alsel)
            console.log("evt", evt)
            console.log("refs", this.$refs)
            console.log("alunni", this.alunni)
            let calendar = this.$refs.fcc.getApi()
            calendar.refetchEvents()
        },
        modsel: async function (evt) {
            console.log("modosel", this.modosel)
            console.log("evt", evt)
            console.log("refs", this.$refs)
            let calendar = this.$refs.fcc.getApi()
            calendar.refetchEvents()
        },
        fprogsel: async function () {
            this.alsel = {}
            // elenco alunni (attenzione: simile nel ChangeCalendar)
            var als
            if (window.MODULIJOIN) {
                console.log("PROGSEL", this.progsel, this.loctimeSQL)
                als = await API.sqlprep(this, "registro.selalsjoin", [
                    this.progsel.progettoid,
                    this.loctimeSQL,
                    this.progsel.progettoid,
                    this.loctimeSQL,
                    this.loctimeSQL,
                    this.progsel.progettoid
                ]);
            } else {
                console.log("PROGSEL", this.progsel, this.loctimeSQL)
                als = await API.sqlprep(this, "registro.selalschange", [ this.progsel.progettoid ]);
            }
            var als2
            if (!window.ENAC) {
                if (window.MODULIJOIN) {
                    als2 = await API.sqlprep(this, "registro.selalsapprjoin", [
                        this.progsel.progettoid,
                        this.loctimeSQL,
                        this.progsel.progettoid,
                        this.loctimeSQL,
                        this.progsel.progettoid,
                        this.loctimeSQL
                    ]);
                } else {
                    als2 = await API.sqlprep(this, "registro.selalsappr", [
                        this.progsel.progettoid,
                        this.progsel.progettoid,
                        this.loctimeSQL,
                    ]);
                }
            }
            var alunni = als.data.dati
                .map(m => ({
                    alunnoid: m.alunnoid,
                    corsistaid: m.corsistaid,
                    ingresso: m.ingresso ? m.ingresso.substr(0, 19) : '',
                    nome: m.cognome + " " + m.nome,
                    cognome: m.cognome,
                    progettoid: m.progettoid, // serve nel caso di moduli condivisi
                    posizione: m.posizione || 0
                }))
                .sort((a, b) => {
                    return a.posizione - b.posizione;
                });
            var alunni2 = window.ENAC ? [] : als2.data.dati
                .map(m => ({
                    alunnoid: m.alunnoid,
                    corsistaid: m.corsistaid,
                    ingresso: m.ingresso,
                    nome: m.cognome + " " + m.nome,
                    cognome: m.cognome,
                    progettoid: m.progettoid, // serve nel caso di moduli condivisi
                    posizione: "APPR"
                }))
                .sort((a, b) => {
                    if (a.nome < b.nome) return -1;
                    else if (a.nome > b.nome) return 1;
                    else return 0;
                });
            this.alunni = alunni.concat(alunni2);
        },
        viewRender(view, element) {
            console.log("viewRender", view.type, element)
            this.viewType = view.type
        },
        click: function (event) {
            console.log("click", event);
            let evdate = event.event.startStr.split("T")[0]
            let nowDate = DateTime.local().toISODate()
            //   console.log("ectest",this.canEdit,evdate,nowDate,event.event.backgroundColor)
            if (event.event._def.extendedProps.tp == 3 && event.calid > 0 && this.sostegno && this.canEdit && (evdate >= nowDate || this.backOK)) {
                this.okDel = true;
                this.cal2del = event.event._def.extendedProps.calid;
            } else if (event.event.backgroundColor == "DarkRed" && (this.getAlunnoID() > 0 && evdate == nowDate)) { //   || window.DEBUG
                console.log("DIALOG ?")
                this.calid = event.event._def.extendedProps.calid
                this.present = event.event.title.endsWith("(P)")
                this.okStage = true;
                let calendar = this.$refs.fc.getApi()
                calendar.refetchEvents()
                // this.$refs.fc.fireMethod("refetchEvents");
            }
        },
        dblClick: async function (event) {
            console.log("dblClick", event.event);
            if (!window.ENAC) return;
            // se è uno stage az2 lo converto in az1
            // se è uno stage az1 lo converto in az2 solo se è possibile
            let dataora = event.event.startStr.substring(0, 19).replace("T", " ")
            let alid = this.alsel.alunnoid
            let calid = event.event._def.extendedProps.calid
            let az1 = event.event._def.extendedProps.az1
            let stg1id, stg2id
            try {
                stg1id = (await API.sqlprep(this, "calendario.stgid", [alid, dataora, 0])).data.dati[0].stageid;
            } catch (e) {
                stg1id = 0
            }
            try {
                stg2id = (await API.sqlprep(this, "calendario.stgid", [alid, dataora, 1])).data.dati[0].stageid;
            } catch (e) {
                stg2id = 0
            }
            console.log("AZ1", az1, stg1id, stg2id, dataora)
            let calendar = this.$refs.fcc.getApi()
            if (!az1) {
                await API.sqlprep(this, "calendario.updstg", [stg1id, calid, alid, dataora]);
                calendar.refetchEvents()
            } else if (az1 && stg2id) {
                await API.sqlprep(this, "calendario.insstg", [calid, alid, dataora, stg2id]);
                await API.sqlprep(this, "calendario.updstg", [stg2id, calid, alid, dataora]);
                calendar.refetchEvents()
            }
        },
        eventClick: function (event) {
            this.clickCount++;
            if (this.clickCount === 1) {
                this.clickTimer = setTimeout(() => {
                    this.clickCount = 0;
                    console.log("SINGLE CLICK");
                    this.click(event);
                }, 300);
            } else if (this.clickCount === 2) {
                clearTimeout(this.clickTimer);
                this.clickCount = 0;
                console.log("DOUBLE CLICK");
                this.dblClick(event);
            }
        },
        dateClick: function (event) {
            let evdate = event.format("YYYY-MM-DD")
            let nowDate = DateTime.local().toISODate()
            console.log("dateClick", event, evdate, nowDate);
            // console.log("dateClick", event.format("YYYY-MM-DD hh:mm"),evdate,nowDate);
            if (this.sostegno && this.viewType != 'month' && this.canEdit && (evdate >= nowDate || this.backOK)) {
                this.dateIns = event.format("YYYY-MM-DD hh") + ":00";
                this.okIns = true;
                let calendar = this.$refs.fc.getApi()
                calendar.refetchEvents()
                // this.$refs.fc.fireMethod("refetchEvents");
            }
        },
        eventRender: function (event) {
            // console.log("EVENTRENDER", this.getUserName()); // funzione globale !
        },
    },
};
</script>

<style>
/*!
 * FullCalendar v3.9.0
 * Docs & License: https://fullcalendar.io/
 * (c) 2018 Adam Shaw
 */
/*!
 * FullCalendar v3.9.0 Print Stylesheet
 * Docs & License: https://fullcalendar.io/
 * (c) 2018 Adam Shaw
 */
/*
 * Include this stylesheet on your page to get a more printer-friendly calendar.
 * When including this stylesheet, use the media='print' attribute of the <link> tag.
 * Make sure to include this stylesheet IN ADDITION to the regular fullcalendar.css.
 */
@media print {
    .fc {
        max-width: 100% !important;
    }

    /* Global Event Restyling
  --------------------------------------------------------------------------------------------------*/
    .fc-event {
        background: #fff !important;
        color: #000 !important;
        page-break-inside: avoid;
    }

    .fc-event .fc-resizer {
        display: none;
    }

    /* Table & Day-Row Restyling
  --------------------------------------------------------------------------------------------------*/
    .fc th,
    .fc td,
    .fc hr,
    .fc thead,
    .fc tbody,
    .fc-row {
        border-color: #ccc !important;
        background: #fff !important;
    }

    /* kill the overlaid, absolutely-positioned components */
    /* common... */
    .fc-bg,
    .fc-bgevent-skeleton,
    .fc-highlight-skeleton,
    .fc-helper-skeleton,
    .fc-bgevent-container,
    .fc-business-container,
    .fc-highlight-container,
    .fc-helper-container {
        display: none;
    }

    /* don't force a min-height on rows (for DayGrid) */
    .fc tbody .fc-row {
        height: auto !important;
        /* undo height that JS set in distributeHeight */
        min-height: 0 !important;
        /* undo the min-height from each view's specific stylesheet */
    }

    .fc tbody .fc-row .fc-content-skeleton {
        position: static;
        /* undo .fc-rigid */
        padding-bottom: 0 !important;
        /* use a more border-friendly method for this... */
    }

    .fc tbody .fc-row .fc-content-skeleton tbody tr:last-child td {
        /* only works in newer browsers */
        padding-bottom: 1em;
        /* ...gives space within the skeleton. also ensures min height in a way */
    }

    .fc tbody .fc-row .fc-content-skeleton table {
        /* provides a min-height for the row, but only effective for IE, which exaggerates this value,
      making it look more like 3em. for other browers, it will already be this tall */
        height: 1em;
    }

    /* Undo month-view event limiting. Display all events and hide the "more" links
  --------------------------------------------------------------------------------------------------*/
    .fc-more-cell,
    .fc-more {
        display: none !important;
    }

    .fc tr.fc-limited {
        display: table-row !important;
    }

    .fc td.fc-limited {
        display: table-cell !important;
    }

    .fc-popover {
        display: none;
        /* never display the "more.." popover in print mode */
    }

    /* TimeGrid Restyling
  --------------------------------------------------------------------------------------------------*/
    /* undo the min-height 100% trick used to fill the container's height */
    .fc-time-grid {
        min-height: 0 !important;
    }

    /* don't display the side axis at all ("all-day" and time cells) */
    .fc-agenda-view .fc-axis {
        display: none;
    }

    /* don't display the horizontal lines */
    .fc-slats,
    .fc-time-grid hr {
        /* this hr is used when height is underused and needs to be filled */
        display: none !important;
        /* important overrides inline declaration */
    }

    /* let the container that holds the events be naturally positioned and create real height */
    .fc-time-grid .fc-content-skeleton {
        position: static;
    }

    /* in case there are no events, we still want some height */
    .fc-time-grid .fc-content-skeleton table {
        height: 4em;
    }

    /* kill the horizontal spacing made by the event container. event margins will be done below */
    .fc-time-grid .fc-event-container {
        margin: 0 !important;
    }

    /* TimeGrid *Event* Restyling
  --------------------------------------------------------------------------------------------------*/
    /* naturally position events, vertically stacking them */
    .fc-time-grid .fc-event {
        position: static !important;
        margin: 3px 2px !important;
    }

    /* for events that continue to a future day, give the bottom border back */
    .fc-time-grid .fc-event.fc-not-end {
        border-bottom-width: 1px !important;
    }

    /* indicate the event continues via "..." text */
    .fc-time-grid .fc-event.fc-not-end:after {
        content: "...";
    }

    /* for events that are continuations from previous days, give the top border back */
    .fc-time-grid .fc-event.fc-not-start {
        border-top-width: 1px !important;
    }

    /* indicate the event is a continuation via "..." text */
    .fc-time-grid .fc-event.fc-not-start:before {
        content: "...";
    }

    /* time */
    /* undo a previous declaration and let the time text span to a second line */
    .fc-time-grid .fc-event .fc-time {
        white-space: normal !important;
    }

    /* hide the the time that is normally displayed... */
    .fc-time-grid .fc-event .fc-time span {
        display: none;
    }

    /* ...replace it with a more verbose version (includes AM/PM) stored in an html attribute */
    .fc-time-grid .fc-event .fc-time:after {
        content: attr(data-full);
    }

    /* Vertical Scroller & Containers
  --------------------------------------------------------------------------------------------------*/
    /* kill the scrollbars and allow natural height */
    .fc-scroller,
    .fc-day-grid-container,
    .fc-time-grid-container {
        /* */
        overflow: visible !important;
        height: auto !important;
    }

    /* kill the horizontal border/padding used to compensate for scrollbars */
    .fc-row {
        border: 0 !important;
        margin: 0 !important;
    }

    /* Button Controls
  --------------------------------------------------------------------------------------------------*/
    .fc-button-group,
    .fc button {
        display: none;
        /* don't display any button-related controls */
    }
}
</style>
<style>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3); /* semi-trasparente 30% */
  z-index: 1000;
  pointer-events: all; /* blocca eventi mouse agli elementi sottostanti */
}
</style>